import { Star } from 'lucide-react'
import { statusConfig } from '../../lib/catalogConfig'
import type { Product } from '../../types'

interface Props {
  status: Product['status']
  showDot?: boolean
}

export default function StatusBadge({ status, showDot = true }: Props) {
  const { label, cls, dotColor } = statusConfig[status]
  return (
    <span className={`flex items-center gap-1.5 px-2.5 py-1 
      ${status === 'sale' ? `border border-[#F0A500]` : ''} 
      rounded-full text-[11px] font-semibold ${cls}`}>
      {showDot && (
        <>
        {status === 'sale' 
        ? <Star className={`w-3 h-3 lg:w-2.5 lg:h-2.5 ${cls}`} aria-hidden="true" /> 
        :  <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: dotColor }} aria-hidden="true" />
        }
        
        </>
      )}
      {label}
    </span>
  )
}